import { useEffect, useState } from 'react';
import '../q.css'
import { useParams } from "react-router-dom"
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Button, CopyButton, Heading, TButton } from '../Key';
import AttachKeyOverlay from './AttachKeyOverlay/AttachKeyOverlay';
import SharedRegionProviderOverlay from '../SharedRegionProviderOverlay';


const shortenIdForMobile = (processingId) => {
    const id = String(processingId);
    const idStart = id.slice(0, 4);
    const idInBetween = '...';
    const idEnd = id.slice(id.length - 4, id.length);
    return `${idStart}${idInBetween}${idEnd}`;
}

const KeyRow = ({ type = 'outline', keyInformation }) => {


    const navigate = useNavigate()
    const getPlan = (num) => {
        const n = parseInt(num);

        if (n === 0) {
            return 'Base';
        } else if (n === 1) {
            return 'Premium';
        } else if (n === 2) {
            return 'Deeplink';
        } else if (n === 3) {
            return 'Family';
        } else if (n === 4) {
            return '1m / 🇬🇧';
        } else if (n === 5) {
            return '1m / 🇫🇮';
        } else if (n === 6) {
            return '1m / 🇩🇪';
        } else if (n === 7) {
            return '1m / Yota';
        } else if (n === 8) {
            return '6m / 🇬🇧';
        } else if (n === 9) {
            return '6m / 🇫🇮';
        } else if (n === 10) {
            return '1m / 🇺🇸';
        } else if (n === 11) {
            return '6m / Yota';
        } else if (n === 12) {
            return '1m / 🇷🇺';
        } else if (n === 13) {
            return '6m / 🇩🇪';
        } else if (n === 14) {
            return '6m / 🇺🇸';
        } else if (n === 15) {
            return 'Family 1y';
        } else if (n === 99) {
            return 'Trials (99)';
        }

        if (n === 20) {
            return 'Я в Китае';
        }
        if (n === 21) {
            return 'Я в Китае / 6м';
        }
        if (n === 30) {
            return 'Бизнес';
        }

    };

    const openKey = (id) => {
        if (type === 'vless') {
            navigate('/vless-key/' + id)
        } else {
            navigate("/key/" + id);
        }
    }

    const getIpAddressFromConfiguration = () => {
        try {
            return JSON.stringify(atob(keyInformation.configuration)).split("@")[1].split("?")[0]
        } catch (e) {
            return ""
        }
    }


    return (
        <div className="row-qiwi t-key-row" onClick={() => openKey(keyInformation.id)}>
            <div className="qiwi-column">
                <div className={(!keyInformation.is_archieved && keyInformation.is_active) ? 'status-round green' : 'status-round red'}></div>
            </div>
            <div className="qiwi-column">{getPlan(keyInformation.plan)}</div>
            {type === 'vless' ?
                <div className="qiwi-column" style={{ fontSize: '10px' }}>{getIpAddressFromConfiguration()}</div>
                :
                <div className="qiwi-column">{keyInformation.configuration.server}</div>
            }
            <div className="qiwi-column">{new Date(keyInformation.expire_date).toLocaleDateString()}</div>
            <div className="qiwi-column wallet-hidden">{(shortenIdForMobile(keyInformation.id))}</div>
            <div className="qiwi-column mobile-hidden"></div>
        </div>
    );
}

const OrderRow = ({ order }) => {
    return <div className="row-qiwi">
        <div className="qiwi-column">
            <div className={(order.is_paid) ? 'status-round green' : 'status-round red'}></div>
        </div>
        <div className="qiwi-column">{order.price === 0 ? 'Deeplink' : <>{order.price} ₽</>}</div>
        {/* <div className="qiwi-column">{keyInformation.configuration.server}</div> */}
        <div className="qiwi-column">{new Date(order.order_date).toLocaleString()}</div>
        <div className='qiwi-column'>{order.order_type}</div>
        <div className="qiwi-column" style={{ textAlign: 'center' }}>
            {(order.id)}<br /> {order.order_type === 'umoney' && order.yookassa_id !== '' && <>({order.yookassa_id})</>}
        </div>
    </div>
}

export default function Profile() {


    const { id } = useParams();
    const navigate = useNavigate()

    const [user, setUser] = useState(null);
    const [userKeys, setUserKeys] = useState(null);
    const [userVlessKeys, setUserVlessKeys] = useState(null);

    const [isOldKeysVisible, setOldKeysVisible] = useState(false)
    const [isOldVlessKeysVisible, setOldVlessKeysVisible] = useState(false)


    const [userOrders, setUserOrders] = useState(null);
    const [webUser, setWebUser] = useState(null);
    const [recoveredPassword, setRecoveredPassword] = useState(null);
    const [isEmailEditOpen, setEmailEditOpen] = useState(false);
    const [editedEmail, setEditedEmail] = useState('');
    const [userNotFound, setUserNotFound] = useState(false);

    const [torrentWarnings, setTorrentWarnings] = useState(0);
    const [isUserBanned, setUserBanned] = useState(false);
    const [doYouWantToBanUser, setDoYouWantToBanUser] = useState(false);

    const [isTokenGenerating, setTokenGenerating] = useState(false);
    const [isUniversalTokenCopied, setUniversalTokenCopied] = useState(false);

    const [isAttachNewKeyOpen, setAttachNewKeyOpen] = useState(false);

    const [isProviderAndRegionOverlayOpened, setProviderAndRegionOverlayOpened] = useState(false);
    const [databaseRegion, setDatabaseRegion] = useState(null);
    const [databaseProvider, setDatabaseProvider] = useState(null);
    const [generatedToken, setGeneratedToken] = useState(null);

    const [paymentSystemSetting, setPaymentSystemSetting] = useState(null);
    const [isPaymentSystemSaving, setPaymentSystemSaving] = useState(false);
    const [isPaymentSystemSettingsOpened, setPaymentSystemSettingsOpened] = useState(false);

    useEffect(() => {
        if (isUniversalTokenCopied === true) {
            setTimeout(() => {
                setUniversalTokenCopied(false);
            }, 3000);
        }
    }, [isUniversalTokenCopied]);

    useEffect(() => {
        fetchUser();
    }, [])


    const copyGeneratedToken = () => {
        navigator.clipboard.writeText(generatedToken);
        setUniversalTokenCopied(true);
    }

    const getUniversalToken = async () => {
        if (isTokenGenerating) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setTokenGenerating(true);
        const data = {
            chat_id: user.id, nickname: user.username, token: 1
        }

        const request = await axios.post('https://ger.wa.48.defaultbot.com/v5/getIdentityVerificationCode', data, { headers: { Authorization: `Bearer ${token}` } });
        const { ok } = request.data;
        if (ok) {
            const { token } = request.data;
            setGeneratedToken(token);
        } else {
            alert("Something went wrong");
        }

        setTokenGenerating(false);
    }

    const savePaymentSystemForUser = async () => {

        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        if (isPaymentSystemSaving) {
            return;
        }

        setPaymentSystemSaving(true)
        const requestBody = {
            id: id,
            payment_system: paymentSystemSetting,
        }

        console.log(requestBody)

        const request = await axios.post('https://ger.wa.48.defaultbot.com/v4/setPaymentSystem', requestBody, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request;
        if (data.ok) {
            alert("Платежная система сохранена");
            setPaymentSystemSettingsOpened(false);
        } else {
            alert("Что-то пошло не так");
        }

        setPaymentSystemSaving(false);
    }

    const fetchUser = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const request = await axios.post('https://ger.wa.48.defaultbot.com/v4/get-user', { id: id }, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request;
        console.log({ data })
        if (data.web) {
            setWebUser(data.web);
        }

        if (data.user === undefined || data.user === null) {
            setUserNotFound(true);
            return;
        }

        setUser(data.user);
        setUserBanned(data.user.is_banned);
        setTorrentWarnings(data.user.torrent_warnings);
        setUserKeys(data.keys);
        setUserVlessKeys(data.vlessKeys);
        setUserOrders(data.orders);
        console.log(data);
        setPaymentSystemSetting(data.payment_system);
        console.log({ps:data.payment_system })
        setDatabaseProvider(data.regionAndProvider.provider);
        setDatabaseRegion(data.regionAndProvider.region);
    }

    const handleWebPasswordRecovery = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setRecoveredPassword(null);
        const requestURL = 'https://ger.wa.48.defaultbot.com/v5/recoverPassword'
        const requestData = {
            id: webUser.id
        }
        console.log({ requestData })
        const req = await axios.post(requestURL, requestData, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = req;
        console.log(data);
        if (data.ok) {
            const { password } = data;
            setRecoveredPassword(password);
        }
    }


    const warnUserAboutTorrents = async (event) => {
        event.preventDefault();
        const data = {
            chat_id: user.id,
            token: "b9de2f43-6c2d-4bee-80e5-71e1d49ce0a4",
        }

        const request = await axios.post("https://directx.simplesmm.org/api/torrents/warn", data);
        console.log(request.data);
        fetchUser();
    }


    const dropTorrentsCounter = async (event) => {
        event.preventDefault();
        const data = {
            chat_id: user.id,
            token: "b9de2f43-6c2d-4bee-80e5-71e1d49ce0a4",
        }

        const request = await axios.post("https://ger.wa.48.defaultbot.com/v5/dropTorrentsCounter", data);
        console.log(request.data);
        fetchUser();
    }

    const confirmBanUser = (event) => {
        event.preventDefault();
        setDoYouWantToBanUser(true);
    }

    const banUser = async (event) => {
        event.preventDefault();
        const data = {
            chat_id: user.id,
            token: "b9de2f43-6c2d-4bee-80e5-71e1d49ce0a4",
        }

        const request = await axios.post("https://directx.simplesmm.org/api/torrents/ban", data);
        console.log(request.data);
        fetchUser();
    }

    const unbanUser = async (event) => {
        event.preventDefault();
        const data = {
            chat_id: user.id,
            token: "b9de2f43-6c2d-4bee-80e5-71e1d49ce0a4",
        }

        const request = await axios.post("https://directx.simplesmm.org/api/torrents/unban", data);
        console.log(request.data);
        fetchUser();
    }

    const editEmail = async (event) => {
        event.preventDefault();
        setEditedEmail(webUser.email)
        setEmailEditOpen(true);
    }

    const updateUserEmail = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const requestURL = 'https://ger.wa.48.defaultbot.com/v5/editEmail'
        const requestData = {
            id: webUser.id,
            email: editedEmail.toLowerCase().trim()
        }
        setEmailEditOpen(false);
        const request = await axios.post(requestURL, requestData, { headers: { Authorization: `Bearer ${token}` } });
        const { ok } = request.data;
        if (ok) {
            alert("Успешно обновлен")
            fetchUser();
        } else {
            alert('Что-то пошло не так');
        }
    }


    if (userNotFound === true) {
        return <div className="content-block t-container">
            <div className="t-content split">
                <div className="page-header"><h1>Пользователя нет в базе данных</h1>

                    <button className='t-close-page-btn' onClick={() => { navigate('/') }}>
                        ❌
                    </button>
                </div></div></div>
    }

    if (user === null) {
        return <div className="content-block t-container">
            <div className="t-content split">
                <div className="page-header">Загрузка...</div></div></div>
    }

    return (
        <>
            {isPaymentSystemSettingsOpened && <div className='overlay' id='overlay' onClick={(e) => {
                const id = e.target.id;
                if (id === 'overlay') {
                    setPaymentSystemSettingsOpened(false);
                }
            }}>
                <div className='overlay-content'>
                    <div>
                        Платежная система пользователя
                    </div>
                    <select className='t-input' value={paymentSystemSetting} onChange={e => setPaymentSystemSetting(e.target.value)}>
                        <option value="lava">Lava</option>
                        <option value="umoney">UMoney</option>
                        <option value={null}>Авто</option>
                    </select>
                    <button className='t-button' onClick={() => { 
                        savePaymentSystemForUser();
                    }}> {isPaymentSystemSaving ? "Сохраняем..." : "Сохранить"}</button>
                </div>
            </div>}
            {isProviderAndRegionOverlayOpened && <>
                <SharedRegionProviderOverlay
                    chat_id={user.id}
                    region={databaseRegion}
                    setRegion={setDatabaseRegion}
                    provider={databaseProvider}
                    setProvider={setDatabaseProvider}
                    close={() => {
                        setProviderAndRegionOverlayOpened(false);
                        fetchUser();
                    }}
                />
            </>}
            {doYouWantToBanUser && <div className='overlay' id='overlay' onClick={(e) => {
                const id = e.target.id;
                if (id === 'overlay') {
                    setDoYouWantToBanUser(false);
                }
            }}>
                <div className='overlay-content'>
                    <div>
                        Вы хотите забанить пользователя?
                    </div>
                    <button onClick={(event) => {
                        setDoYouWantToBanUser(false);
                        banUser(event);
                    }} className='t-button'>Да</button>
                    <button onClick={(event) => {
                        event.preventDefault();
                        setDoYouWantToBanUser(false)
                    }} className='t-button'>Нет</button>
                </div>
            </div>}
            {isEmailEditOpen && <div className='overlay' id='overlay' onClick={(e) => {
                const id = e.target.id;
                if (id === 'overlay') {
                    setEmailEditOpen(false);
                }
            }}>
                <form onSubmit={updateUserEmail} className='overlay-content'>
                    <div>
                        Обновить email пользователя
                    </div>
                    <input type='email' required className='t-input' value={editedEmail} onChange={e => setEditedEmail(e.target.value)} />
                    <button type='submit' className='t-button'>Обновить</button>
                </form>
            </div>}
            {isAttachNewKeyOpen && <AttachKeyOverlay chat_id={user.id} close={() => setAttachNewKeyOpen(false)} />}
            <div className="content-block t-container">
                <div className="t-updated-content">
                    <div className="page-header">
                        <div></div>
                        <button className='t-close-page-btn' onClick={() => { navigate('/') }}>
                            ❌
                        </button>
                    </div>
                    <Heading icon={'🫅🏻'} text={"Пользователь"} />
                    <div className='t-data-double'>
                        <div className="t-data-block">@{user.username}</div>
                        <div className="t-data-block">{user.id}</div>
                    </div>

                    <div className="t-data-block">{new Date(user.created_at).toLocaleDateString()}</div>

                    <div className='t-data-double'>
                        <div className='t-data-block'>{databaseRegion !== '' ? databaseRegion : "Регион не установлен"}</div>
                        <div className='t-data-block'>{databaseProvider !== '' ? databaseProvider : "Провайдер не установлен"}</div>
                    </div>
                    <TButton disabled={false} onClick={() => {
                        setProviderAndRegionOverlayOpened(true)
                    }} text={"⚙️ Регион / Оператор"} />
                    <TButton disabled={false} onClick={() => {
                        setPaymentSystemSettingsOpened(true)
                    }} text={`💵 Платежная система: ${paymentSystemSetting}`}/>
                    {user.username !== undefined && user.username !== null &&
                        <TButton onClick={() => window.open(`https://telegram.me/${user.username}`, '_blank')} text={'🪡 Telegram'} />}
                    {webUser !== null && <>
                        <Heading icon={'🕸️'} text={"Личный Кабинет"} />
                        <div className='t-data-block'>{webUser.email}</div>
                        <TButton onClick={editEmail} text={'📦 Изменить почту'} />
                        <TButton onClick={handleWebPasswordRecovery} text={'🤐 Сменить пароль'} />
                        {recoveredPassword !== null && <CopyButton copyValue={recoveredPassword} text={'✏️ Копировать новый пароль'} activeText="✅ Скопировано" />}
                    </>}
                    <TButton onClick={() => getUniversalToken()} text={isTokenGenerating ? "Генерируем..." : "🔑 Универсальный токен"} />
                    {generatedToken !== null && <TButton onClick={() => copyGeneratedToken()} text={isUniversalTokenCopied ? "Токен скопирован" : "Нажми чтобы скопировать токен"} />}
                    <Heading icon={'👺'} text={"Торренты"} />
                    <div className='t-data-block'>Предупреждений: {torrentWarnings}</div>
                    <TButton onClick={warnUserAboutTorrents} text={'Прислать предупреждение'} />
                    <TButton onClick={dropTorrentsCounter} text={'Сбросить счетчик торрентов'} />
                    {isUserBanned && <span className="t-data-block error">Пользователь забанен</span>}
                    {isUserBanned && <TButton onClick={unbanUser} text={'🔨 Разбанить'} />}
                    {!isUserBanned && <TButton onClick={confirmBanUser} text={'🔨 Забанить'} />}
                    <TButton onClick={() => setAttachNewKeyOpen(true)} text={"Выдать новый ключ"} />
                    <Heading icon={'🔑'} text={"Ключи пользователя - Outline"} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {userKeys && userKeys.filter((uk) => (uk.is_active === true && uk.is_archieved === false)).map((key) => {
                            return <KeyRow type='outline' keyInformation={key} />
                        })}
                        <button className='t-button' onClick={() => setOldKeysVisible(!isOldKeysVisible)}>{isOldKeysVisible ? <>Скрыть старые ключи</> : <>Показать старые ключи</>}</button>
                        {isOldKeysVisible === true && userKeys && userKeys.filter((uk) => (uk.is_active === false || uk.is_archieved === true)).map((key) => {
                            return <KeyRow type='outline' keyInformation={key} />
                        })}
                    </div>
                    <Heading icon={'🔑'} text={"Ключи пользователя - Vless"} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {userVlessKeys && userVlessKeys.filter((uvk) => uvk.is_active === true && uvk.is_archieved === false).map((key) => {
                            return <KeyRow type='vless' keyInformation={key} />
                        })}
                        <button className='t-button' onClick={() => setOldVlessKeysVisible(!isOldVlessKeysVisible)}>{isOldVlessKeysVisible ? <>Скрыть старые ключи</> : <>Показать старые ключи</>}</button>
                        {isOldVlessKeysVisible === true && userVlessKeys && userVlessKeys.filter((uk) => (uk.is_active === false || uk.is_archieved === true)).map((key) => {
                            return <KeyRow type='vless' keyInformation={key} />
                        })}
                    </div>
                    <Heading icon={'🛒'} text={"Заказы пользователя"} />
                    {userOrders.map((order) => {
                        return <OrderRow order={order}></OrderRow>
                    })}
                </div>
            </div></>
    )
}
